import { render, staticRenderFns } from "./ProvidingYourBankDetails.vue?vue&type=template&id=5998bdcc"
import script from "./ProvidingYourBankDetails.vue?vue&type=script&lang=js"
export * from "./ProvidingYourBankDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports